import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { DestinationListType01Component } from '../../destination-list/destination-list-type01/destination-list-type01.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-testimonial-type02',
  standalone: true,
  imports: [MatIconModule, DecimalPipe, CurrencyPipe, DestinationListType01Component, MatTooltipModule, RouterLink],
  templateUrl: './testimonial-type02.component.html',
  styleUrl: './testimonial-type02.component.scss'
})
export class TestimonialType02Component implements OnInit {

  public view: any = {
  }

  constructor(public tfmService: TFMService, private route: ActivatedRoute) {
    this.tfmService.getTestimonials().then(res => {
      this.view.testimonials = res;
    });
  }

  ngOnInit(): void {
    this.tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this.tfmService.getSiteProfile(this.view.site.profileID);
      // this._tfmService.log(this.view);

    });
  }
}
